<template>
  <UserTypeSelector
    :userTypeList="userTypeList"
    :currentUserTypes="selectedUserTypes"
    :isVisible="initialUserTypes.length > 1"
    @userTypeChange="updateUserTypes"
  />
</template>

<script>
import UserTypeSelector from "./UserTypeSelector.vue";
import { ROLE_FUNCTION_TO_USER_TYPE_MAP } from "./UserTypeSelector.constants";
export default {
  name: "userTypeContainer",
  props: {
    canChangeUserType: Boolean,
    storeGetter: Function,
    storeSetter: Function,
  },
  components: { UserTypeSelector },
  data() {
    return {
      userTypeList: [],
      selectedUserTypes: [],
      initialUserTypes: [],
    };
  },

  methods: {
    async fetchUserType() {
      const payload = {
        link: "user-types",
      };
      try {
        const response = await this.$store.dispatch(
          "fetchStrapiContent",
          payload
        );
        this.userTypeList = (response && response.data) || [];
      } catch (error) {
        this.errors.push(error);
      }
    },

    updateUserTypes(userTypes) {
      this.selectedUserTypes = userTypes || [];
      if (this.storeSetter) {
        this.storeSetter(this.selectedUserTypes);
      }
      this.$emit("userTypeChange", this.selectedUserTypes);
    },
  },

  async mounted() {
    this.fetchUserType();

    const roleFunctions = this.$store.getters.GET_CURRENT_USER_ROLE_FUNCTIONS;
    const userTypes = roleFunctions
      .map((roleFunction) => {
        return ROLE_FUNCTION_TO_USER_TYPE_MAP[roleFunction];
      })
      .filter(Boolean);

    this.selectedUserTypes =
      this.storeGetter && this.storeGetter() ? this.storeGetter() : userTypes;
    this.initialUserTypes = userTypes;
    this.$emit("userTypeChange", this.selectedUserTypes);
  },
};
</script>
